var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"track-container"},[_c('track-map'),_c('track-way'),_c('track-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }